// Lightweight scroll-reveal helper using IntersectionObserver
// Usage: add data-reveal="up|down|left|right|fade|zoom" and optional data-reveal-delay="120" to any element.

export function initRevealOnScroll(options = {}) {
  const { rootMargin = '0px 0px -10% 0px', threshold = 0.15 } = options;

  // Respect reduced motion
  if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const els = document.querySelectorAll('[data-reveal]');
    els.forEach((el) => el.classList.add('reveal-visible'));
    return () => {};
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = el.getAttribute('data-reveal-delay');
        if (delay) {
          const ms = parseInt(delay, 10);
          if (!Number.isNaN(ms)) {
            el.style.transitionDelay = `${ms}ms`;
          }
        }
        el.classList.add('reveal-visible');
        observer.unobserve(el);
      }
    });
  }, { rootMargin, threshold });

  // Observe current nodes and any added later (simple mutation observer)
  const observeAll = () => {
    document.querySelectorAll('[data-reveal]:not(.reveal-observed)').forEach((el) => {
      el.classList.add('reveal-observed');
      observer.observe(el);
    });
  };

  observeAll();

  const mo = new MutationObserver(() => observeAll());
  mo.observe(document.body, { childList: true, subtree: true, attributes: false });

  return () => {
    observer.disconnect();
    mo.disconnect();
  };
}
